enum Environment {
    test = 'test',
    local = 'local',
    idev = 'idev',
    sandbox = 'sandbox',
    iqa = 'iqa',
    prod = 'prod',
}

export type Env = Environment;

// old backend api
export const getBackendURLFromHost = (hostname: string) => {
    hostname = hostname.toUpperCase();
    if (/SANDBOX/gi.test(hostname)) {
        return 'https://sandbox.golendica.com/api/v1';
    }
    if (/DEV/gi.test(hostname)) {
        return 'https://idev.golendica.com/api/v1';
    }
    if (/QA/gi.test(hostname)) {
        return 'https://iqa.golendica.com/api/v1';
    }
    if (/LOCAL/gi.test(hostname) || /127\.0\.0\.1/gi.test(hostname)) {
        if (process.env.NODE_ENV === 'development') {
            // return 'http://165.227.93.225:8000/api/v1';
            return 'https://idev.golendica.com/api/v1';
        } else {
            // return 'http://127.0.0.1:8000/api/v1';
            return 'https://sandbox.golendica.com/api/v1';
        }
    }
    return 'https://prod.golendica.com/api/v1';
};

export const getEnvFromHost = (hostname: string) => {
    hostname = hostname.toUpperCase();
    if (/SANDBOX.GOLENDICA/gi.test(hostname)) {
        return Environment.sandbox;
    }
    if (/DEV.GOLENDICA/gi.test(hostname)) {
        return Environment.idev;
    }
    if (/QA.GOLENDICA/gi.test(hostname)) {
        return Environment.iqa;
    }
    if (/LOCAL/gi.test(hostname) || /127\.0\.0\.1/gi.test(hostname)) {
        return Environment.local;
        return Environment.idev;
    }
    if (/vercel.app/gi.test(hostname)) {
        return Environment.idev;
    }
    return Environment.prod;
};

export const matchBackend = (version = 'v1') => {
    if (/idev.golendica/gi.test(`${window.location}`)) {
        return `https://api-dev.golendica.com/api/${version}`;
    }
    if (/sandbox.golendica/gi.test(`${window.location}`)) {
        return `https://api-sandbox.golendica.com/api/${version}`;
    }
    if (/iqa.golendica/gi.test(`${window.location}`)) {
        return `https://api-qa.golendica.com/api/${version}`;
    }
    if (/local/gi.test(`${window.location}`) || /127.0.0.1/gi.test(`${window.location}`)) {
        return `http://165.227.93.225:8000/api/${version}`;
        return `https://api-dev.golendica.com/api/${version}`;
    }
    if (/vercel.app/gi.test(`${window.location}`)) {
        return `https://api-dev.golendica.com/api/${version}`;
    }
    return `https://api.golendica.com/api/${version}`;
};

export const matchHostname = () => {
    if (/idev.golendica/gi.test(`${window.location}`)) {
        return 'app-idev.golendica.com';
    }
    if (/sandbox.golendica/gi.test(`${window.location}`)) {
        return 'app-sandbox.golendica.com';
    }
    if (/iqa.golendica/gi.test(`${window.location}`)) {
        return 'app-iqa.golendica.com';
    }
    if (/local/gi.test(`${window.location}`) || /127.0.0.1/gi.test(`${window.location}`)) {
        return 'app-idev.golendica.com';
    }
    if (/vercel.app/gi.test(`${window.location}`)) {
        return 'app-idev.golendica.com';
    }
    return 'app.golendica.com';
};

export const detectUserAgent = () => {
    // Detect if the host environment is web browser, ios app, android app, or mobile web browser.
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Check for iOS environment (WKWebView or browser)
    if (userAgent.match(/iPad|iPhone|iPod/) && !window.MSStream) {
        if (
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.downloadHandler
        ) {
            return 'iOSApp';
        } else {
            return 'iOSBrowser';
        }
    }

    // Check for Android environment (WebView or browser)
    if (/android/i.test(userAgent)) {
        if (window.AndroidDownloadHandler) {
            return 'AndroidApp';
        } else {
            return 'AndroidBrowser';
        }
    }

    // Default to web environment
    return 'Web';
};
